import EquinetTeams from './EquinetTeams';

export default EquinetTeams;
